<header class="main-header">
  <div class="navbar-wrapper">
    <div class="navbar navbar-expand-lg navbar-light static-top">
      <a class="navbar-brand" routerLink="/client/list">
        <figure>
          <img src="assets/apptunix.png" alt="Apptunix"/>
        </figure>
      </a>

      <!-- View Selector next to logo on desktop -->
      <div class="view-selector-wrap" *ngIf="type && type.length > 0">
        <mat-select (selectionChange)="changeViewType($event)" [(ngModel)]="singleType" disableOptionCentering="true">
          <mat-select-trigger>
            {{ getSelectedViewTypeLabel() }}
          </mat-select-trigger>
          <mat-option [value]="item.value" *ngFor="let item of type">
            {{ formatViewType(item) }}
          </mat-option>
        </mat-select>
      </div>

      <button class="navbar-toggler" type="button" (click)="toggleMenu()" aria-controls="navbarSupportedContent" [attr.aria-expanded]="!isMenuCollapsed" aria-label="Toggle navigation">
        <i class="fas" [ngClass]="isMenuCollapsed ? 'fa-bars' : 'fa-times'"></i>
      </button>

      <div class="collapse navbar-collapse" [class.show]="!isMenuCollapsed" id="navbarSupportedContent">
        <ul class="navbar-nav w-100 justify-content-end align-items-center">
          <!-- Mobile-only view selector (only when menu is expanded) -->
          <li class="nav-item mobile-view-selector" *ngIf="!isMenuCollapsed && type && type.length > 0">
            <mat-select (selectionChange)="changeViewType($event)" [(ngModel)]="singleType" disableOptionCentering="true">
              <mat-select-trigger>
                {{ getSelectedViewTypeLabel() }}
              </mat-select-trigger>
              <mat-option [value]="item.value" *ngFor="let item of type">
                {{ formatViewType(item) }}
              </mat-option>
            </mat-select>
          </li>

          <!-- Navigation Pills -->
          <li class="nav-item" *ngFor="let data of moduleData; let i=index">
            <a class="nav-pill-btn" [class.active]="isActiveRoute(data.route)" (click)="redirect(data)">
              {{ data?.name }}
            </a>
          </li>

          <!-- Subtle Divider -->
          <li class="nav-divider"></li>

          <!-- Profile -->
          <!-- <li class="nav-item">
            <a class="action-btn-pill profile-btn" (click)="$event.preventDefault()">
              <i class="far fa-user-circle"></i>
              <span>Profile</span>
            </a>
          </li> -->

          <!-- Logout -->
          <li class="nav-item cursor-pointer">
            <a class="action-btn-pill logout-btn" (click)="logout()">
              <i class="fas fa-sign-out-alt"></i>
              <span>Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
